const PRESERVED_TAGS = new Set(["PRE", "TEXTAREA", "SCRIPT", "STYLE"]);

function isElement(node) {
    return node?.nodeType === Node.ELEMENT_NODE;
}

function isComment(node) {
    return node?.nodeType === Node.COMMENT_NODE;
}

function shouldRemove(text) {
    const previous = text.previousSibling;
    const next = text.nextSibling;

    if (!previous || !next) {
        return true;
    }

    if (isComment(previous) || isComment(next)) {
        return true;
    }

    return isElement(previous) && isElement(next) && /[\r\n]/.test(text.textContent);
}

export function condenseWhitespace(root) {
    Array.from(root.childNodes).forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
            if (child.textContent.trim() !== "") {
                return;
            }

            if (shouldRemove(child)) {
                child.remove();
            } else {
                child.textContent = " ";
            }

            return;
        }

        if (isElement(child) && !PRESERVED_TAGS.has(child.tagName)) {
            condenseWhitespace(child);
        }
    });

    return root;
}

document.addEventListener("livewire:init", () => {
    Livewire.hook("morph", ({ el, toEl }) => {
        if (el.closest("#app")) {
            condenseWhitespace(toEl);
        }
    });
});
